var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNafInsuranceChipShieldCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84559 0.158234L16.1419 2.98887L16.8171 3.24907L16.8593 3.96992C16.9612 5.72807 16.687 8.41102 15.5477 11.0342C14.3978 13.6785 12.3443 16.3087 8.88779 17.8066L8.44122 18L7.99464 17.8066C4.53108 16.3122 2.48107 13.6855 1.33123 11.0377C0.191948 8.41453 -0.0823242 5.72807 0.0196489 3.97343L0.0618446 3.25259L0.736976 2.98887L8.03332 0.158234L8.4377 0L8.84559 0.158234ZM1.14135 4.04024C0.954988 7.24712 2.15405 14.0582 8.4377 16.7763C14.7249 14.0582 15.9239 7.24712 15.7376 4.04024L8.4377 1.20609L1.14135 4.04024ZM12.0349 6.19223L11.7044 6.64583L7.99113 11.7515L7.5973 12.293L7.13315 11.8113L5.22027 9.83161L4.82996 9.42723L5.63871 8.64661C5.72311 8.73452 6.33494 9.36746 7.47775 10.5489L10.7971 5.98476L11.1277 5.53116L12.0384 6.19223H12.0349Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafInsuranceChipShieldCheckmark);
export default __webpack_public_path__ + "static/media/naf-insurance-chip-shield-checkmark.60843cd4de15ae8f13e9c7ca728dff71.svg";
export { ForwardRef as ReactComponent };